/** ISO 3166-1 alpha-2 — usado com SVG (emojis de bandeira quebram no Windows). */
export const LANGUAGES = [
  { code: 'pt-BR', nativeLabel: 'Português (Brasil)', flagCountry: 'BR' },
  { code: 'pt-PT', nativeLabel: 'Português (Portugal)', flagCountry: 'PT' },
  { code: 'es', nativeLabel: 'Español', flagCountry: 'ES' },
  { code: 'en', nativeLabel: 'English', flagCountry: 'US' },
]

export const DEFAULT_LANGUAGE = 'pt-BR'

export const SUPPORTED = LANGUAGES.map((l) => l.code)

export function resolveLanguage(raw) {
  if (!raw) return null
  const value = String(raw)
  if (SUPPORTED.includes(value)) return value
  const lower = value.toLowerCase()
  if (lower.startsWith('pt-br')) return 'pt-BR'
  if (lower.startsWith('pt-pt')) return 'pt-PT'
  if (lower.startsWith('pt')) return 'pt-BR'
  if (lower.startsWith('es')) return 'es'
  if (lower.startsWith('en')) return 'en'
  return null
}
